/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GoogleService {
    /**
     * Google merchant feed
     * @returns any Google merchant feed
     * @throws ApiError
     */
    public static getApiVGoogleFeedXml({
        houseNumber,
        apiVersion = 1,
    }: {
        houseNumber: number,
        apiVersion?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/google/{houseNumber}/feed.xml',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
        });
    }
}
